export default __webpack_public_path__ + "static/ebookstore-dea2217db9a6f31c82231182aca015a1.png";